<template>
  <small class="text-xs text-neutral-500 mt-0.5 block" data-testid="form-helper-text">
    <slot />
  </small>
</template>
